import { useOverduePayment } from '@/hooks/billing/useOverduePayment';
export const OverduePaymentIcon = () => {
  const {
    overduePayment
  } = useOverduePayment();
  if (!overduePayment?.id) {
    return null;
  }
  return <svg className="absolute -right-1 -bottom-0.5 h-4 w-4" fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="OverduePaymentIcon" data-sentry-source-file="OverduePaymentIcon.tsx">
      <title>warning icon over user menu icon</title>
      <g clipPath="url(#clip0_248_416)" data-sentry-element="g" data-sentry-source-file="OverduePaymentIcon.tsx">
        <rect fill="#FC5252" height="10" rx="5" width="10" x="1" y="1" data-sentry-element="rect" data-sentry-source-file="OverduePaymentIcon.tsx" />
        <path d="M6.08533 3.63853V6.12433" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2429" data-sentry-element="path" data-sentry-source-file="OverduePaymentIcon.tsx" />
        <path d="M6.08533 8.61012H6.09154" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2429" data-sentry-element="path" data-sentry-source-file="OverduePaymentIcon.tsx" />
      </g>
      <rect className="stroke-white dark:stroke-gray-950" height="10.9375" rx="5.46875" strokeWidth="0.9375" width="10.9375" x="0.53125" y="0.53125" data-sentry-element="rect" data-sentry-source-file="OverduePaymentIcon.tsx" />
      <defs data-sentry-element="defs" data-sentry-source-file="OverduePaymentIcon.tsx">
        <clipPath id="clip0_248_416" data-sentry-element="clipPath" data-sentry-source-file="OverduePaymentIcon.tsx">
          <rect fill="white" height="10" rx="5" width="10" x="1" y="1" data-sentry-element="rect" data-sentry-source-file="OverduePaymentIcon.tsx" />
        </clipPath>
      </defs>
    </svg>;
};